<app-lfsa-card-v2 [innTemplate]="enviarTemplate" [titulo]="titulo" [modulo]="'IO-Industrias'" [tituloCard]="'Ordenes de proceso'" *ngIf="!mostrarFormulario && !mostrarFormularioRasp">
</app-lfsa-card-v2>
<ng-template #enviarTemplate>
  <div class="row col-md-12 animated fadeInRight">
    <h2 class="container float-left"> Buscar </h2>
    <hr />
    <div class="container">
      
      <div class="row">
        <div class="form-group col-md-12">
          &nbsp;
          <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
            (keyup)="onQuickFilterChanged() " #quickFilter />
        </div>
        
      </div>
    
      <div class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <div *ngIf="!loading">
            <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
              No existen ordenes de procesos pendientes por solicitar.
            </div>
            <ag-grid-angular *ngIf="!listaVacia" 
              #agGrid class="{{tvcModulo.agGrid.class}}" 
              [ngStyle]="tvcModulo.agGrid.style" id="{{tvcModulo.agGrid.id}}"
              [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs" [rowSelection]="rowSelection"
              [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
              [paginationPageSize]="tvcModulo.agGrid.paginacion">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>



<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Selecione la Linea a asignar'" [idButton]="'abrirModal'"
  [idOpen]="'Modal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <form [formGroup]="formularioCustom" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-6">
        <app-lfsa-combo-box [class]="'letrasDanger'" (change)="getLineaPlanta()" [mostrarImg]="false" [rutaImagen]="''"
          [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="cmbPlanta" formControlName="planta"
          [control]="formularioCustom.get('planta')" [label]="'Planta'" [id]="'planta'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-combo-box [class]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]="''"
          [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="cmbLinea" formControlName="linea"
          [control]="formularioCustom.get('linea')" [label]="'Línea'" [id]="'linea'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioCustom.invalid" (click)="enviarSolicitud()">Enviar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
